import React from 'react'
import * as C from "../componentsM/index";

const CareerAndUniCounseling = () => {
    return (

        <>

            <C.Hero title={"CAREER & UNIVERSITY COUNSELLING"}/>

            <section className='p-5 md:p-20'>

                <div className='flex flex-col gap-2'>
                <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">
                    
                        
                        One of the most important decisions students and parents will have to make is of thinking about applying for higher education? This decision will factor a combination of the</h1>

                </div>



                <div className='flex flex-col gap-5 py-8'>
                
                    <ul className="list-disc list-inside my-2">
                        {[
                            "Choice of subject based on interest, career or profession?",
                            "Choice of college or university?",
                            "Choice of country or location?",
                            "Academic achievements?",
                            "Affordability?",
                            "Travel restrictions and considerations.",
                            "(Advice to students: You must not feel pressurised to enter higher education, by parents, peers, family, cultural or societal norms but remember as you have to personally live and experience it; the choice has to be yours. As your interest in what you are doing will make you succeed)"
                        ]
                            .map(v => <li className='font-semibold mb-3' key={v}>{v}</li>)}
                    </ul>

                </div>

                <div className='flex flex-col gap-5 py-8 font-semibold mb-3'>

                    <p>Irrespective of any and all limitations in the above there is a college and university which will accept you as a learner. However, limitations are inversely related to the number of college or university options available to you i.e. more the limitations less the choices of college or university for you to apply too.</p>

                    <p>According to Vikki Pickering during your years at Higher Education the development of a range of skills and competencies are required for “adding value” to any organisation or cause, namely:</p>

                </div>

                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">Brainpower</h1>

                    <p>Above all, employers seek a suitable level of intellectual capability.</p>

                    <div>
                        <p>Ability to communicate:</p>


                        <p>Writing for and presenting to a wide range of audiences is vital. It is not of much use having the brainpower if you can’t convey your ideas.</p>
                    </div>

                    <div>
                        <p>Problem solving and analytical skills:</p>
                        <p>The ability to gather and interpret data in an accurate, logical, clear and concise manner.</p>
                    </div>

                </div>



                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">Teamwork</h1>

                    <p>Organisations operate by solving problems in teams. Working with others, showing personal organisation and time management, imagination and open-mindedness are vital.</p>

                    <div>
                        <p>Networking: Making contacts and using your interpersonal skills.</p>

                    </div>

                    <div>
                        <p>Technical ability:</p>
                        <p>Some jobs need this more than others. It ranges from understanding computer packages to familiarity with modern laboratory equipment and techniques.</p>
                    </div>

                </div>




                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">Self-awareness</h1>

                    <p>This involves an understanding of your strengths and weaknesses as well as a belief in your ability to go on learning. It covers being able to focus and reflect and encompasses motivation.</p>

                </div>



                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">Flexibility:</h1>

                    <p>This involves a positive reaction to change, versatility and the ability to be multi-skilled and adaptable. Your job could change many times to reflect customer demands and as technology, products and processes advance.</p>

                    <p>The value of higher education, in terms of life benefits, is great; experience of different perspectives; increased confidence; greater awareness of people and situations and the changes in opinions they bring about; the prospect of experimentation (interpret this as you will!); the chance to make mistakes and the opportunity to learn from them. You will also have the chance to be responsible for yourself by dealing with your own finances and the other realities of life: washing, cooking, shopping and ironing. Although not glamorous, they have to be done! 1</p>

                    <p>For personalised advice regarding college or university choices and admission contact the Career & University Counsellor.</p>


                    <p>International Recognition of IB Diploma:</p>

                    <p>The IB diploma is accepted in colleges and universities in 75 countries including USA, UK, Canada, Australia, Hong Kong, Malaysia, India, France, Germany, Spain and Pakistan (http://www.ibo.org/diploma/recognition/).</p>

                </div>




                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">College and Universities Application Process and Deadlines</h1>

                    <p>It is highly advised to commence the research on college and university choices in the first year of the Diploma Programme (Grade 11).</p>


                </div>



                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">Grade 11 (First Year of Diploma Programme)</h1>

                    <p>September to January Research options</p>
                    <p>January Prepare tentative list of colleges and universities</p>
                    <p>January to June Appear of SAT I exams for US colleges and universities</p>


                </div>


                <div className='flex flex-col gap-5 py-8'>

                    <h1 className="font-bold text-xl md:text-3xl text-myBlue">Grade 12 (Second Year of Diploma Programme)</h1>

                    <p>June to September for SAT I exam, Appear for SAT II and TOEFL (if required)</p>
                    <p>15 October closing date for Oxbridge, medicine, dentistry in UK</p>
                    <p>December to March Application deadlines for US Colleges</p>
                    <p>15 January UCAS closing date for applications from UK and EU students</p>


                    <div>
                        <p>USA Colleges and Universities</p>
                        <p>We highly recommend</p>
                    </div>

                    <div>
                        <ul className="list-disc list-inside my-2">
                            {[
                                "getting assistance for colleges and universities in the USA from The United States Educational Foundation Pakistan (http://www.usefpakistan.org/)",
                                "Researching choices on http://www.collegeboard.com/?student",
                                "Using www.commonaps.org (if possible) to apply to US colleges and universities"
                            ]
                                .map(v => <li className='font-semibold mb-3' key={v}>{v}</li>)}
                        </ul>
                    </div>

                    <div>
                        <p>Australian Colleges and Universities</p>
                        <p>We highly recommend</p>
                    </div>



                    <div>
                        <ul className="list-disc list-inside my-2">
                            {[
                                "Researching on http://www.australian-universities.com/",
                                "Researching on http://www.goingtouni.gov.au\\/"
                            ]
                                .map(v => <li className='font-semibold mb-3' key={v}>{v}</li>)}
                        </ul>
                    </div>


                    <div>
                        <p>Canadian Colleges and Universities</p>
                        <p>We highly recommend</p>
                    </div>


                    <div>
                        <ul className="list-disc list-inside my-2">
                            {[
                                "Researching on http://www.edu.gov.on.ca/eng/general/postsec/postsec.html",
                                "Researching on http://www.aucc.ca/can_uni/our_universities/index_e.html",
                                "Applying for Ontario universities on http://www.ouac.on.ca/105/index.html"
                            ]
                                .map(v => <li className='font-semibold mb-3' key={v}>{v}</li>)}
                        </ul>
                    </div>

                    <div>
                        <p>Pakistani Colleges and Universities</p>
                        <p>UK Colleges and Universities</p>
                        <p>We highly recommend</p>
                    </div>


                    <div>
                        <ul className="list-disc list-inside my-2">
                            {[
                                "Researching on individual university’s website",
                                "Reviewing information on www.unionview.org.uk",
                                "Applying with http://www.ucas.co.uk (ask college counsellor for buzzword before commencing this process)"
                            ]
                                .map(v => <li className='font-semibold mb-3' key={v}>{v}</li>)}
                        </ul>
                    </div>


{/* 
                    <div>
                        <p className='text-2xl'>1 The Value of Education by Vikki Pickering</p>
                    </div> */}


                </div>


            </section>


        </>
    )
}

export default CareerAndUniCounseling